





















import { NewObject } from "@/helper/shareHelper";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component
export default class DropdownVatType extends Vue {
  @Prop({}) readonly index!: number;
  @Prop({}) readonly transactionItem!: any;
  @Prop({}) readonly transactionCreate!: any;

  private optionsVatType = [
    { name: "ไม่มี", value: 1 },
    { name: "0%", value: 2 },
    { name: "7%", value: 3 },
  ];
  private selectVatType: any = { name: "7%", value: 3 };

  @Watch("transactionItem.vatTypeId.value", { immediate: true })
  vatTypeIdChanged(newVal: any) {
    if (newVal === 0) {
      this.SelectTransactionItemVatType(this.optionsVatType[2]);
    } else {
      this.SelectTransactionItemVatType(this.optionsVatType[newVal - 1]);
    }
  }

  @Watch("selectVatType")
  selectVatTypeChanged(newVal: any, oldVal: any) {
    if (newVal.value != oldVal.value) {
      this.SelectTransactionItemVatType(newVal);
      this.$emit("change");
    }
  }

  public SelectTransactionItemVatType(item: any) {
    this.selectVatType = NewObject(item);
    this.transactionItem.vatTypeId.value = item.value;
  }
}
